import { useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getAssignedBrands } from "store/actions/brandsAction"

export const useAssignedBrands = () => {
  const dispatch = useDispatch()
  const accountType = useSelector(state => state.Login?.accountType)
  const accountScope = useSelector(state => state.Login?.accountScope)
  const isSuperAdminSession =
    accountScope === "super_admin" || accountType === "superadmin"
  const {
    assignedBrands,
    assignedBrandsLoading,
    assignedBrandsLoaded,
    defaultBrandId,
  } = useSelector(state => state.Brands)

  useEffect(() => {
    if (isSuperAdminSession || assignedBrandsLoaded || assignedBrandsLoading) {
      return
    }
    dispatch(getAssignedBrands())
  }, [
    dispatch,
    isSuperAdminSession,
    assignedBrandsLoaded,
    assignedBrandsLoading,
  ])

  const brands = useMemo(
    () => assignedBrands || [],
    [assignedBrands]
  )

  return {
    brands,
    defaultBrandId,
    loading:
      !isSuperAdminSession &&
      assignedBrandsLoading &&
      !assignedBrandsLoaded,
    loaded: isSuperAdminSession || assignedBrandsLoaded,
    hasOnlyOneBrand: brands.length === 1,
  }
}

export const canViewBrandOrders = (brand, hasOrdersViewPermission = false) => {
  if (!brand) {
    return false
  }

  return Boolean(hasOrdersViewPermission)
}

export const getBrandOrdersBasePath = brandId => `/orders/${brandId}`

export const getBrandDisplayName = brand =>
  brand?.displayName || brand?.brandName || ""

/** MongoDB ObjectId-looking path segment under /orders/:brandId */
export const isOrdersBrandIdSegment = (segment = "") =>
  /^[a-f\d]{24}$/i.test(String(segment))

/**
 * Label for order brand context: "Orders" when tenant has one brand,
 * otherwise the brand display name.
 */
export const getOrdersBrandLabel = (brands = [], brandId, ordersLabel = "Orders") => {
  if (!Array.isArray(brands) || brands.length <= 1) {
    return ordersLabel
  }
  const brand = brands.find(entry => entry.brandId === brandId)
  return getBrandDisplayName(brand) || ordersLabel
}
